<n-slide-window
    width="6.5rem"
    [visible]="windowVisible"
    [showMask]="false"
    [outClickHide]="true"
    (onHide)="close()">
    <!-- 标题 -->
    <n-header>
        <h1 nTextTips>{{i18n.excludeFilePath}}</h1>
    </n-header>

    <div class="file-path-container">
        <span  class="file-path-container-value">{{filePath}}</span>
    </div>

    <n-footer>
        <button id="file-path-detail-close-btn"
            nButton
            [label]="i18n.closeBtn"
            (click)="hide()"></button>
    </n-footer>
</n-slide-window>
